/** Стиль-пак «mono-glam» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'mono-glam',
  shape: {
    radiusCard: 8, radiusOption: 24, radiusButton: 'pill', radiusImage: 8,
    borderWidth: 0, borderTone: 'none', selectionMode: 'border', shadow: 'none',
  },
  density: { optionHeight: 42, optionPadY: 10, optionPadX: 20, gap: 16, contentMaxWidth: 460, screenPadX: 20 },
  type: {
    headingFamily: 'sans', h1Size: 30, h1Weight: 700, h1Tracking: 0,
    qSize: 30, qWeight: 700, qTracking: 0, optionSize: 14, optionWeight: 400,
    headingAlign: 'center', overlineTransform: 'uppercase',
  },
  chrome: { progress: 'bar', progressLabel: 'none', counter: false, backButton: 'icon-bare', logo: 'center' },
  cta: { placement: 'none', fullWidth: true, height: 52, disabledStyle: 'grey' },
  states: { selected: 'filled', hoverTint: true, transitionMs: 200, screenFadeMs: 0 },
  imagery: {
    optionCard: 'label-overlay-bottom', overlayTone: 'dark', frame: 'rounded',
    promptHint: 'catalogue studio series, same grey backdrop, same outfit, only the subject varies',
  },
  // GLOV: каталожная серия и чёрные плашки; композиция держит середину,
  // а ровное чёрное затемнение — часть ахроматического языка пака.
  layout: { alignY: 'center', alignX: 'center', backgroundOverlay: 'scrim-full' },
  // GLOV-глянец: одна крупная цифра в кольце по центру пустого экрана —
  // ахроматике идёт скупость, плюс короткая цитата вместо перечня стадий.
  loader: {
    style: 'ring', showPercent: true, socialProof: 'review',
    answersSummary: false, engagementModals: true,
  },
  // GLOV-глянец: моноширинный отсчёт — часть ахроматической графики, скидка
  // объявляется плоской плашкой. Чёрная шапка-крышка над выбранным тарифом,
  // соседи гаснут (ахроматике нужен контраст яркости вместо цвета).
  paywall: {
    timer: 'mono-header', promoTicket: 'plain', priceMode: 'per-month',
    planHighlight: 'cap-header', dimUnselectedPlans: true,
    stickyHeader: true, repeatPurchaseBlock: false,
  },
  // Ахроматика по определению не вводит зелёный: деньги остаются цветом
  // текста, а единственная цветовая роль — премиальность.
  accents: { money: 'none', premium: 'accent' },
};
